import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../utils/utils';
// `font-roobert` is explicit because the apps only set the family on a fixed
// list of elements that excludes <li>, so bare list items would fall back to the default sans.
export const Callout = ({ tone = 'warning', icon, className, children, ...props }) => (_jsx("div", { ...props, className: cn('rounded-lg border border-solid p-3 font-roobert text-sm text-neutral-800', {
        'border-orange-200 bg-orange-100/40': tone === 'warning',
        'border-blue-200 bg-blue-100/40': tone === 'info',
        'border-emerald-200 bg-emerald-100/40': tone === 'success',
        'border-red-200 bg-red-100/40': tone === 'danger',
        'border-neutral-200 bg-neutral-50': tone === 'neutral',
        'flex items-start gap-2.5': icon
    }, className), children: icon ? (_jsxs(_Fragment, { children: [_jsx("span", { "aria-hidden": "true", className: cn('mt-0.5 inline-flex shrink-0 [&>svg]:size-4', {
                    'text-orange-500': tone === 'warning',
                    'text-blue-500': tone === 'info',
                    'text-emerald-600': tone === 'success',
                    'text-red-500': tone === 'danger',
                    'text-neutral-400': tone === 'neutral'
                }), children: icon }), _jsx("div", { className: "min-w-0 flex-1", children: children })] })) : (children) }));
